module.exports = __webpack_public_path__ + "static/media/23116746_1638426969565821_544453920592817758_o-thumb.5a46445e.jpg";